import type Eshop from '@eshop/type/eshop'

export class ProductPriceHelper {
    /**
     * Promování (žluté) slevy.
     * 
     * B2C - sleva za 30dní stejná a větší než 5%
     * B2B - když je v akce
     */
    static hasDiscountPromo(product: Eshop.Product<'detail' | 'price'>): boolean {
        return product.price.isB2B
            ? product.detail.isFeatured
            : product.price.discountPercent30days >= 5
    }

    /**
     * Má se zobrazit původní cena
     */
    static hasDiscount(product: Eshop.Product<'price'>): boolean {
        return product.price.discountPercentOrigin > 0 || product.price.discountPercent30days >= 5
    }

    /**
     * Má se zobrazit procento slevy
     */
    static isDiscountPercentVisible(product: Eshop.Product<'price'>): boolean {
        return product.price.isB2B 
            ? product.price.discountPercentOrigin > 0 
            : product.price.discountPercent30days >= 5
    }

    /**
     * Získá správné procento slevy podle B2B statusu
     */
    static getDiscountPercent(product: Eshop.Product<'price'>): number {
        return product.price.isB2B 
            ? product.price.discountPercentOrigin 
            : product.price.discountPercent30days
    }
}